import styled from "styled-components";

export const SAddProjectModalSectionBreadcrumb = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;
